import { ReactElement } from 'react';
import { connect } from 'react-redux';
import MyBookmarkCommon from 'pages/bookmark/bookmark-common/MyBookmark';
import { IStoreState } from 'store';
import { addBookmark, setBookmarkName, deleteBookmark } from 'store/bookmark/actions';
import { clearModalContent, setModalContent } from 'store/modal/actions';
import { IBookmarkObjState } from 'store/bookmark/types';

interface TAddNewBookmarkStateProps {
  bookmarkName: string;
  bookmarks: IBookmarkObjState[];
  addBookmarkSuccess: boolean;
}

export interface TAddNewBookmarkDispatchProps {
  clearModalContent: () => void;
  setModalContent: (content: ReactElement) => void;
  addBookmark: () => void;
  deleteBookmark: (id: string) => void;
  setBookmarkName: (bookmarkName: string, bookmarkLink: string, bookmarkModule: string) => void;
  bookmarkLink: string;
  bookmarkModule: string;
}

export type TAddNewBookmarkProps = TAddNewBookmarkStateProps & TAddNewBookmarkDispatchProps;

const mapStateToProps = (state: IStoreState): TAddNewBookmarkStateProps => ({
  bookmarkName: state.bookmark ? state.bookmark.bookmarkName : '',
  bookmarks: state.bookmark ? state.bookmark.bookmarks : [],
  addBookmarkSuccess: state.bookmark ? state.bookmark.addBookmarkSuccess : false,
});

const mapDispatchToProps = {
  setBookmarkName,
  addBookmark,
  deleteBookmark,
  setModalContent,
  clearModalContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyBookmarkCommon);
